import IconCard from "../../views/workflows/IconCard";
import React from "react";

const iconsMap = {
  Owner: "mdi mdi-crown",
  Administrator: "mdi mdi-shield-crown",
  Architect: "mdi mdi-wrench",
  Contributor: "mdi mdi-hand-coin",
  Viewer: "mdi mdi-eye",
};

const PermissionList = ({
  permissions,
  selectedPermission,
  onChange,
  filterOwner = false,
}) => {
  return (
    permissions?.length > 0 &&
    permissions.map((permission, i) => {
      const isSelected = selectedPermission === permission.id;
      if (filterOwner && permission?.Owner === true) return null;

      const role = permission?.Name?.split?.(" ")?.[1];

      return (
        <React.Fragment key={`permission-${i}`}>
          <IconCard
            icon={iconsMap[role || "Administrator"]}
            name={permission?.Name}
            description={permission?.Description}
            css="mb-3"
            isSelected={isSelected}
            onClick={() => onChange(permission.id)}
            iconOutline={false}
          />
        </React.Fragment>
      );
    })
  );
};

export default PermissionList;
